import React from 'react';

const BgProducts = () => {
    return (
        <div
            className="bg-products-page d-flex justify-content-center align-items-center text-center flex-column"
            style={{
                background: "linear-gradient(to right, rgba(0,0,0,0.45), rgba(0,0,0,0.75)), url('../assets/sample-image/bgProduct33.png') no-repeat center"
            }}>
            <div className="text-bg">
                <h1 className="xmb-4">گوشی موبایل</h1>
            </div>
        </div>
    );
};
export default BgProducts;
